import { render, staticRenderFns } from "./OrderPropertyReportForm.vue?vue&type=template&id=624ddef2&scoped=true&"
import script from "./OrderPropertyReportForm.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ddef2",
  null
  
)

export default component.exports